// extracted by mini-css-extract-plugin
export default {"createSpleis":"Sknri","callToActionBox":"paNQ6"};